// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { configureStore } from "@reduxjs/toolkit";
import ballotStylesReducer from "./ballotStyles/ballotStylesSlice";
// note: use Immer, https://immerjs.github.io/immer/
export var store = configureStore({
    reducer: {
        ballotStyles: ballotStylesReducer,
    },
});
